// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2yZ_i","cell":"ColumnAccessor_cell__3VTqK","firstCellAccent":"ColumnAccessor_firstCellAccent__2QSZB"};